import { render } from "./MenuIsoGrow.vue?vue&type=template&id=1df1440f&scoped=true"
import script from "./MenuIsoGrow.vue?vue&type=script&lang=js"
export * from "./MenuIsoGrow.vue?vue&type=script&lang=js"

import "./MenuIsoGrow.vue?vue&type=style&index=0&id=1df1440f&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df1440f"]])

export default __exports__